/** @format */

import {
  Add,
  BubbleChart,
  GetApp,
  HourglassEmpty,
  Remove,
} from '@mui/icons-material';
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListSubheader,
  Paper,
} from '@mui/material';

const icons = {
  'File Received': GetApp,
  'File Processed': HourglassEmpty,
  'Positive Impact Revenue Sum': Add,
  'Negative Impact Revenue Sum': Remove,
};

function AboutFile({ aboutData }) {
  const titles = Object.keys(aboutData);
  const list = titles.map((title) => ({
    title,
    value: aboutData[title],
    Icon: icons[title] || BubbleChart,
  }));
  return (
    <Paper elevation={4}>
      <List
        sx={{
          flex: '1 1 360px',
        }}
        subheader={
          <ListSubheader
            disableSticky
            component="div"
            id="nested-list-subheader"
          >
            About Files
          </ListSubheader>
        }
      >
        {list.map((item) => {
          const { Icon, title, value } = item;
          return (
            <ListItem key={title}>
              <ListItemAvatar>
                <Avatar>
                  <Icon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={title} secondary={value} />
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
}

export default AboutFile;
